import React from 'react';
import {
  carleadCreationGetInitialProps,
  renderFieldVerticalWrapper,
  CarleadCreationForm,
  SplitManufacturers,
  SplitMainTypes,
  SplitBuiltDates,
  SplitFuelType,
  SplitBodyTypes,
  SplitHorsePower,
  SplitMainTypeDetails,
  SplitGearType,
  SplitDoorCount,
  SplitMainTypesSub,
  Email,
  CarleadCreationButton,
  QuestionaireSelect,
  useSplitFieldsProps,
  useFormQuestionnaireProps,
  useCreateNormalCarleadForm,
  useSplitFieldsFlowService,
  defaultCarleadSplitFlow,
  CarleadMileageFormatted,
} from '@wkda/carlead-creation-components';
import { Paper } from '@wkda/styleguide';
import { t } from '@lingui/macro';
import {
  PartnerEventManager,
  PartnerFunnelLayout,
  CustomFormHeader,
  CustomFormFooter,
} from '@wkda/marketing-partner-components';

function CarleadCreation() {
  const questionnaireProps = useFormQuestionnaireProps(defaultCarleadSplitFlow);
  const splitFieldsProps = useSplitFieldsProps();
  const machine = useSplitFieldsFlowService(defaultCarleadSplitFlow);

  const consumerForm = useCreateNormalCarleadForm([
    questionnaireProps,
    splitFieldsProps,
  ]);

  return (
    <PartnerFunnelLayout className="custom-layout">
      <Paper className="carlead-creation-form__container px-3">
        <CustomFormHeader />

        <CarleadCreationForm
          carleadForm={consumerForm}
          options={{ name: 'StepCompound' }}
          machineService={machine}
          bottomContent={<PartnerEventManager />}
        >
          <SplitManufacturers />
          <SplitMainTypes />
          <SplitBuiltDates />
          <SplitBodyTypes isHiddenField />
          <SplitFuelType isHiddenField />
          <SplitMainTypeDetails isHiddenField />
          <SplitHorsePower isHiddenField />
          <SplitGearType isHiddenField />
          <SplitDoorCount isHiddenField />
          <SplitMainTypesSub isHiddenField />

          <CarleadMileageFormatted
            isHiddenField
            renderFieldWrapper={renderFieldVerticalWrapper}
          />
          <QuestionaireSelect
            // @ts-ignore
            renderFieldWrapper={renderFieldVerticalWrapper}
            name="SELLPOINT"
            label={t({
              id: 'carleadCreation.form.label.sellpoint',
            })}
            isHiddenField
            answers={[
              {
                label: t({
                  id: 'carleadCreation.option.sellpointNow',
                }),
                value: 'SELLPOINT_NOW',
              },
              {
                label: t({
                  id: 'carleadCreation.option.sellpoint4weeks',
                }),
                value: 'SELLPOINT_4_WEEKS',
              },
              {
                label: t({
                  id: 'carleadCreation.option.sellpoint3months',
                }),
                value: 'SELLPOINT_3_MONTHS',
              },
              {
                label: t({
                  id: 'carleadCreation.option.sellpointNotPlanned',
                }),
                value: 'SELLPOINT_NOT_PLANNED',
              },
            ]}
          />
          <QuestionaireSelect
            // @ts-ignore
            renderFieldWrapper={renderFieldVerticalWrapper}
            name="SELL_TYPES"
            label={t({
              id: 'carleadCreation.form.label.sellTypes',
            })}
            isHiddenField
            answers={[
              {
                label: t({
                  id: 'carleadCreation.option.sellTypesPrivate',
                }),
                value: 'PRIVATE',
              },
              {
                label: t({
                  id: 'carleadCreation.option.sellTypesDealer',
                }),
                value: 'DEALER',
              },
            ]}
          />

          <Email
            isHiddenField
            renderFieldWrapper={renderFieldVerticalWrapper}
          />

          <CarleadCreationButton />

          <CustomFormFooter />
        </CarleadCreationForm>
      </Paper>
    </PartnerFunnelLayout>
  );
}

CarleadCreation.getInitialProps = carleadCreationGetInitialProps;

export default CarleadCreation;
